import React, { useCallback, useState } from 'react';
import { get } from 'lodash';
import { ATMField, ATMForm, ATMGrid, ATMRadio } from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { IRequestFormMethods } from 'src/models/request.model';
import LabelRequired from 'src/components/atoms/label-required/label-required.component';
import styles from './form-flag.module.scss';

type IProps = IRequestFormMethods & {
  label: string;
  name: string;
  note?: string;
  no?: boolean;
  na?: boolean;
  onChange?: (flag: boolean) => void;
  setValue?: (value: any) => void;
};

const FormFlag: React.FC<IProps> = ({
  control,
  errors,
  label,
  name,
  note,
  no = true,
  na = false,
  onChange,
  setValue,
}) => {
  const [flag, setFlag] = useState<boolean | undefined | null>(
    get(control, `defaultValuesRef.current.${name}`)
  );

  const handleFlag = useCallback(
    (value) => {
      let isChecked;
      if (value === 'na') {
        isChecked = null;
      } else {
        isChecked = value === 'yes';
      }
      control.setValue(name, isChecked, {
        shouldValidate: true,
      });
      if (setValue) {
        setValue(isChecked);
      }

      setFlag(isChecked);

      if (onChange) {
        onChange(isChecked);
      }
    },
    [control, name, setFlag, onChange]
  );

  return (
    <ATMForm.Field name={name} error={!!get(errors, name, false)} inline>
      <ATMGrid style={{ padding: '0' }}>
        <ATMGrid.Row columns="equal" style={{ padding: '0' }}>
          <ATMGrid.Column style={{ padding: '0' }}>
            <LabelRequired>{label}</LabelRequired>
            {note && <div className={styles.note}>({note})</div>}
          </ATMGrid.Column>
          <ATMGrid.Column style={{ padding: '0' }}>
            <ATMField
              key={`flag_${name}`}
              className="hidden"
              as={ATMForm.Input}
              control={control}
              type="hidden"
              name={name}
            />
            <ATMForm.Group>
              <ATMForm.Field>
                <ATMRadio
                  label={Lang.LBL_YES}
                  value="yes"
                  checked={flag === true}
                  onChange={(_, { value }) => handleFlag(value)}
                />
              </ATMForm.Field>
              {no && (
                <ATMForm.Field>
                  <ATMRadio
                    label={Lang.LBL_NO}
                    value="no"
                    checked={flag === false}
                    onChange={(_, { value }) => handleFlag(value)}
                  />
                </ATMForm.Field>
              )}
              {na && (
                <ATMForm.Field>
                  <ATMRadio
                    label={Lang.LBL_NA}
                    value="na"
                    checked={flag === null || flag === false}
                    onChange={(_, { value }) => handleFlag(value)}
                  />
                </ATMForm.Field>
              )}
            </ATMForm.Group>
          </ATMGrid.Column>
        </ATMGrid.Row>
      </ATMGrid>
    </ATMForm.Field>
  );
};

export default FormFlag;
